export default "__VITE_ASSET__DYnRt4XP__"